import { Effect } from 'effect';
import NotesIcon from '@listening/assets/icons/notes.svg?react';

import { NotesSkeleton } from '@/components/web-fe/design-v2/skeletons';
import { createFileRoute } from '@tanstack/react-router';
import {
  listNotesEffect,
  notesQueryKey,
} from '@listening/frontend/query/notes';
import * as m from '@/paraglide/messages';
import { NotesV2 } from '@/components/web-fe/design-v2/notes-v2';
import { DashboardPage } from '@/components/web-fe/pages/dashboard/dashboard-page';
import { eq } from '@/runtimes/effect-query';
import { getRuntime } from '@/runtimes/get-runtime';

export const Route = createFileRoute('/app/_authenticated/_dashboard/notes')({
  component: NotesPage,
  pendingComponent: NotesSkeleton,
  pendingMs: 0,
  // Prefetch the notes list. The per-audio cards fetch their summary by id
  // (`useAudioById`) on demand, so no audio-list prefetch is needed here.
  // Best-effort: `NotesPage` renders its own inline `isError` state, so a
  // prefetch failure must not reject the loader into the root catch boundary.
  // `Effect.ignore` discards both success and failure of the prefetch.
  loader: ({ context: { queryClient } }) =>
    getRuntime().runPromise(
      Effect.ignore(
        Effect.tryPromise(() =>
          queryClient.query({
            ...eq.queryOptions({
              queryKey: notesQueryKey,
              queryFn: () => listNotesEffect(),
            }),
            staleTime: 'static',
          }),
        ),
      ),
    ),
  context: () => ({
    title: m.common_notes(),
    icon: NotesIcon,
  }),
});

function NotesPage() {
  return (
    <DashboardPage>
      <NotesV2 />
    </DashboardPage>
  );
}
